import Plyr from 'plyr';
import getAllFocusableElements from '../../../scripts/shared/mando-ui.getAllFocusableElements';
import { pushToDataLayer } from '@/ui/scripts/analytics/analytics.methods';

const playerEl = document.querySelector('.js-hero-video');

let nextEl;
let videoBtn;
let player;

const keys = {
  tab: 'Tab',
  right: 'ArrowRight',
  left: 'ArrowLeft',
};

const mediaQuery = window.matchMedia('(min-width: 61.25em)');

function handleVideoClick(action) {
  pushToDataLayer('video_tracking', 'video_action', 'video_label', 'Click', action);
}

function windowSize() {
  if (!mediaQuery.matches) {
    player.stop();
  } else {
    if (player) {
      player.play();
    } else {
      player = instantiatePlayer();
      player.on('ready', readyHandler);
    }
  }
}

function findFocusItemsToTrack(heroBtn) {
  const allFocusableEls = Array.from(getAllFocusableElements(document.body));
  const isMatchingBtn = (element) => element === heroBtn;
  const playPauseIndex = allFocusableEls.findIndex(isMatchingBtn); // returns index of playPauseBtn
  const nextFocusableEl = allFocusableEls[playPauseIndex + 1];

  nextEl = nextFocusableEl;
}

function handleHeroBtnFocus(e) {
  const pressed = e.key;

  if ((pressed === keys.tab && !e.shiftKey) || pressed === keys.right) {
    e.preventDefault();
    nextEl.focus();
  }
}

function handleNextElFocus(e) {
  const pressed = e.key;

  if ((pressed === keys.tab && e.shiftKey) || pressed === keys.left) {
    e.preventDefault();
    videoBtn.focus();
  }
}

function instantiatePlayer() {
  return new Plyr(playerEl, {
    controls: ['play', 'pause'],
    hideControls: false,
    autoplay: true,
    loop: { active: true },
    clickToPlay: false,
    muted: true,
    ratio: '16:9',
    vimeo: {
      autoplay: true,
      background: true,
      controls: 0,
      loop: true,
      muted: true,
      responsive: true,
      title: true,
    },
    youtube: {
      autoplay: 1,
      controls: 0,
      loop: 1,
      origin: 1,
    },
  });
}

function readyHandler(event) {
  const instance = event.detail.plyr;
  const playPauseBtn = playerEl.querySelector('[data-plyr=play]');
  instance.muted = true; // force mute vimeo
  instance.play();

  if (playPauseBtn) {
    videoBtn = playPauseBtn;

    videoBtn.addEventListener('click', () => {
      const videoBtnAriaLabel = videoBtn.getAttribute('aria-label');

      // Plyer controls button has an aria label stating play/pause
      if (videoBtnAriaLabel === 'Play') handleVideoClick('Pause');
      if (videoBtnAriaLabel === 'Pause') handleVideoClick('Play');
    });

    findFocusItemsToTrack(videoBtn);

    videoBtn.addEventListener('keydown', handleHeroBtnFocus);
    if (nextEl) nextEl.addEventListener('keydown', handleNextElFocus);
  }
}

function init() {
  if (playerEl === null) {
    return;
  }

  // needed to allow autoplaying
  window.player = player;

  if (mediaQuery.matches) {
    player = instantiatePlayer();
    player.on('ready', readyHandler);
  }

  mediaQuery.addEventListener('change', windowSize);
}

export default init;
